import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message, Select} from 'antd';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';

interface ImageSubCategoryProps {
  imgsubcategoryid: string;
}

const ImageSubCategory: React.FC<ImageSubCategoryProps> = ({imgsubcategoryid}) => {
  const [SubCategoryName, setImageSubCategory] = useState('');
  const [items, setImageCategoryData] = useState<[]>([]);
  const [selectedItem, setSelectedImageCategory] = useState('');
  const { instance, accounts } = useMsal();

  const API_URL = process.env.REACT_APP_API_URL;

  const fetchToken = async () => {
        const res = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        return res.idToken;
      };
    
      useEffect(() => {
        fetchToken();
        getImageCategoryData();
        handleLoadData();
      }, []);
      

  const handleSubmit = async () => {
    if (!SubCategoryName || !selectedItem) {
      message.error('Please fill in all fields');
      return;
    }   

    const letter_only = /^[a-zA-Z]*$/;
    if (!letter_only.test(SubCategoryName)) {
      message.error('Please enter only letters in the Image Sub Category Name field');
      return;
    }

    const userId = localStorage.getItem("UserId");

  // Map jsonData to the expected format and validate required fields
    const mappedData = {
        ImageSubCategoryName: SubCategoryName,
        ImageCategoryId: selectedItem,
        CreatedBy: userId
    };

    try {
      const token = await fetchToken();
      if(imgsubcategoryid === ""){
        await axios.post(`${API_URL}/api/ImageSubCategory/SaveImageSubCategory`, mappedData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
          message.success('Image Sub Category added successfully');
          setImageSubCategory('');
          setSelectedImageCategory('');
      }
      else{
        // Map jsonData to the expected format and validate required fields
        const updatedData = {
            ImageSubCategoryName: SubCategoryName,
            ImageCategoryId: selectedItem,
            UpdatedBy: userId,
            ImageSubCategoryId: imgsubcategoryid
        };

        await axios.put(`${API_URL}/api/ImageSubCategory/UpdateImageSubCategory`, updatedData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
          message.success('Image Sub Category updated successfully');
          setImageSubCategory('');
          setSelectedImageCategory('');
      }
    } catch (error) {
      message.error('Failed to save the data');
    }
  };

  const handleLoadData = async () => {
    if(imgsubcategoryid === "") return;
    try {
      const token = await fetchToken();
      const response = await axios.get(`${API_URL}/api/ImageSubCategory/GetImageSubCategoryById/${imgsubcategoryid}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      setImageSubCategory(response.data.imageSubCategoryName);
      setSelectedImageCategory(response.data.imageCategoryId);
    } catch (error) {
      message.error('Failed to load image sub category data');
    }
  }

  const handleSelectedChange = (value: string) => {
    setSelectedImageCategory(value);
  }

  const getImageCategoryData = async () => {
    try {
      const token = await fetchToken();
      const response = await axios.get(`${API_URL}/api/ImageSubCategory/GetImageCategoryNames`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      
      setImageCategoryData(response.data);
    } catch (error) {
      message.error('Failed to load image category data');
    }
  }

  return (
    <Form layout="vertical" onFinish={handleSubmit}>
      <Form.Item label="Image Category Name" required>
        <Select
          value={selectedItem}
          onChange={handleSelectedChange}
          placeholder="Select"
        >
            {items.map((type: any) => (
              <option key={type.value} value={type.value}>
                {type.text}
              </option>
            ))}
        </Select>
      </Form.Item>
      <Form.Item label="Image Sub Category Name" required>
        <Input
          value={SubCategoryName}
          onChange={(e) => setImageSubCategory(e.target.value)}
          placeholder="Enter image sub category name" maxLength={50}
        />
      </Form.Item>
      
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Save
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ImageSubCategory;